import { render, staticRenderFns } from "./motoristasReport.vue?vue&type=template&id=a887170c&scoped=true"
import script from "./motoristasReport.vue?vue&type=script&lang=js"
export * from "./motoristasReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a887170c",
  null
  
)

export default component.exports